
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[docId]",
      function () {
        return require("private-next-pages/[docId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[docId]"])
      });
    }
  